import React from "react";
import { Table } from "@chakra-ui/react";
import ActionMenu from './Action';
import TruncatedText from '../text/TruncatedText';
import { useColorModeValue } from "../../ui/color-mode";

const TableRows = (props) => {
  const { 
    rows = [], 
    columns = [], 
    actions = [], 
    truncateText = true, 
    maxTextLength = 50, 
    showTooltip = true, 
    allowCopy = true 
  } = props;

  return (
    <Table.Body>
      {rows.map((row) => (
        <EachTableRow
          key={row.id}
          row={row}
          columns={columns}
          actions={actions}
          truncateText={truncateText}
          maxTextLength={maxTextLength}
          showTooltip={showTooltip}
          allowCopy={allowCopy}
        />
      ))}
    </Table.Body>
  );
};

const EachTableRow = ({ 
  row, 
  columns, 
  actions, 
  truncateText, 
  maxTextLength, 
  showTooltip, 
  allowCopy 
}) => {

  const hoverColor = useColorModeValue('#f0f0f0', '#2a2a2a')

  const hasActionColumn = columns.some(column => column.key === 'action');
  
  const handleRowClick = () => {
    if (hasActionColumn && actions[0] && typeof actions[0].function === 'function') {
      actions[0].function(row);
    }
  };

  return (
    <Table.Row
      onClick={handleRowClick}
      _hover={{ 
        background: hasActionColumn && hoverColor, 
        cursor: hasActionColumn ? 'pointer' : 'default' 
      }}
    >
      {columns.map((column) => {
        const cellValue = row[column.key];
        const shouldTruncate = truncateText && (typeof cellValue === 'string' || typeof cellValue === 'number');

        return (
          <Table.Cell
            key={column.key}
            textAlign={column.textAlignItem || 'center'}
            width={column.width}
          >
            {column.key === 'actions' ? (
              <ActionMenu
                row={row}
                actions={actions}
              />
            ) : column.key === 'action' ? null : React.isValidElement(cellValue) ? (
              cellValue
            ) : shouldTruncate ? (
              <TruncatedText
                text={String(cellValue ?? '')}
                maxLength={column.maxTextLength || maxTextLength}
                showTooltip={column.showTooltip ?? showTooltip}
                allowCopy={column.allowCopy ?? allowCopy}
                fontSize="sm"
                fontFamily="Nunito"
                fontWeight={700}
                showInChip={column.showInChip || false}
              />
            ) : (
              cellValue
            )}
          </Table.Cell>
        );
      })}
    </Table.Row>
  );
};

export default TableRows;